export default __webpack_public_path__ + "static/media/cmw-og-image.7b2ed16f.png";